import { UploadProcess } from 'modules/documents/hooks/useGetUploadProcess'

export function isPersonalFilesWorkflow(uploadProcess: UploadProcess) {
  return uploadProcess.distributionWorkflow === 'personal_files'
}
